import { useStore } from 'zustand';
import {
  CombinationButtonStatusEnum,
  IGridStatus,
} from '../../../../../products/products-details-v2/hooks/useCombination';
import { useGridStoreApiOptional } from './GridStoreProvider';
import { emptyGridStore } from './gridStore';
import { selectCombinationButtonStatus } from './gridStore.selectors';

interface UseCombinationButtonStatusParams {
  combinationKey?: string;
  hasEmptyAvailability: boolean;
  fallback: IGridStatus;
}

export const useCombinationButtonStatus = ({
  combinationKey,
  hasEmptyAvailability,
  fallback,
}: UseCombinationButtonStatusParams): IGridStatus => {
  const api = useGridStoreApiOptional();
  const isStoreBacked = !!api && !!combinationKey;

  const combinationCells = useStore(api ?? emptyGridStore, (state) =>
    combinationKey ? state.cells[combinationKey] : undefined,
  );

  if (!isStoreBacked || !combinationKey || fallback.type === CombinationButtonStatusEnum.LOADING) {
    return fallback;
  }

  const storeStatus = selectCombinationButtonStatus({
    cells: { [combinationKey]: combinationCells ?? {} },
    combinationKey,
    hasEmptyAvailability,
    isPending: false,
  });

  const fallbackIsAheadOfStore =
    storeStatus.type === CombinationButtonStatusEnum.ADD &&
    (fallback.type === CombinationButtonStatusEnum.ADDED ||
      fallback.type === CombinationButtonStatusEnum.WITH_PIECES);

  if (fallbackIsAheadOfStore) {
    return fallback;
  }

  return storeStatus;
};
